import {
  AttributeWeight,
  GraphEntityType,
} from '@/components/nodeGraph/utils/types';
import { ResourceType } from '@/types';

export const DefaultAttributeWeights: AttributeWeight[] = [
  { label: 'AS Name', name: 'asname', weight: 20 },
  { label: 'AS Number', name: 'asnumber', weight: 0 },
  { label: 'AS Range', name: 'asrange', weight: 0 },
  { label: 'Domain', name: 'domain', weight: 0 },
  { label: 'Public/Private', name: 'private', weight: 0 },
  { label: 'Attack Surface', name: 'attackSurface', weight: 0 },
  { label: 'Origin', name: 'origins', weight: 0 },
  { label: 'Country', name: 'country', weight: 0 },
];

export const DefaultRiskWeights: AttributeWeight[] = [
  { label: 'Severity', name: 'severity', weight: 0 },
  { label: 'Status', name: 'status', weight: 0 },
];

export const DefaultTechnologyWeights: AttributeWeight[] = [
  { label: 'Vendor', name: 'vendor', weight: 0 },
  { label: 'Product', name: 'product', weight: 0 },
  { label: 'Version', name: 'version', weight: 0 },
];

export const DefaultSeedWeights: AttributeWeight[] = [
  { label: 'Domain', name: 'identifier', weight: 20 }, // Default clustering by domain
  { label: 'Name', name: 'name', weight: 0 },
  { label: 'Registrant', name: 'registrant', weight: 0 },
  { label: 'Registrar', name: 'registrar', weight: 0 },
  { label: 'Status', name: 'status', weight: 0 },
  { label: 'Country', name: 'country', weight: 0 },
  { label: 'Email', name: 'email', weight: 0 },
  { label: 'Source', name: 'source', weight: 0 },
  { label: 'Class', name: 'class', weight: 0 },
  { label: 'Origin', name: 'origin', weight: 0 },
];

export const DefaultSharpHoundWeights: AttributeWeight[] = [
  { label: 'Object Type', name: 'type', weight: 20 },
  { label: 'Domain', name: 'domain', weight: 15 },
  { label: 'Enabled', name: 'enabled', weight: 10 },
];

export const GraphEntityTypeLabel = {
  [ResourceType.Asset]: 'Assets',
  [ResourceType.Risk]: 'Vulnerabilities',
  [ResourceType.Technology]: 'Technologies',
  [ResourceType.Attribute]: 'Attributes',
  [ResourceType.Webpage]: 'Webpages',
  [ResourceType.Seed]: 'Seeds',
  Tag: 'Tags',
  SharpHound: 'SharpHound',
};

export const EntityWeightConfigs: Record<GraphEntityType, AttributeWeight[]> = {
  [ResourceType.Asset]: DefaultAttributeWeights,
  [ResourceType.Risk]: DefaultRiskWeights,
  [ResourceType.Technology]: DefaultTechnologyWeights,
  [ResourceType.Attribute]: DefaultAttributeWeights,
  [ResourceType.Webpage]: [],
  [ResourceType.Seed]: DefaultSeedWeights,
  Tag: [],
  SharpHound: DefaultSharpHoundWeights,
};

export const GraphEntityOptions = [
  {
    label: 'Assets',
    value: ResourceType.Asset,
    id: ResourceType.Asset,
  },
  {
    label: 'Attributes',
    value: ResourceType.Attribute,
    id: ResourceType.Attribute,
  },
  {
    label: 'Vulnerabilities',
    value: ResourceType.Risk,
    id: ResourceType.Risk,
  },
  {
    label: 'Technologies',
    value: ResourceType.Technology,
    id: ResourceType.Technology,
  },
  {
    label: 'Webpages',
    value: ResourceType.Webpage,
    id: ResourceType.Webpage,
  },
];

export const ClusterByEntityOptions = [
  {
    label: 'Assets',
    value: ResourceType.Asset,
    id: ResourceType.Asset,
  },
  {
    label: 'Seeds',
    value: ResourceType.Seed,
    id: ResourceType.Seed,
  },
  {
    label: 'Vulnerabilities',
    value: ResourceType.Risk,
    id: ResourceType.Risk,
  },
  {
    label: 'Technologies',
    value: ResourceType.Technology,
    id: ResourceType.Technology,
  },
];

export const DefaultVisibleAttributes = [
  'asname',
  'asnumber',
  'asrange',
  'country',
  'province',
  'city',
  'purchased',
  'updated',
  'expiration',
  'registrant',
  'registrar',
  'attackSurface',
  'surface',
  'cloudService',
  'cloudId',
  'cloudRoot',
  'cloudAccount',
  'source',
  'origins',
  'class',
  'private',
  // Attributes for webpages
  'attributeName',
  'attributeValue',
];

export const DefaultVisibleAttributesForCluster =
  DefaultVisibleAttributes.slice(0, -2);

export const DefaultRiskClusters = [
  { label: 'Severity', value: 'severity', id: 'severity' },
  { label: 'Status', value: 'status', id: 'status' },
];

export const DefaultTechnologyClusters = [
  { label: 'Vendor', value: 'vendor', id: 'vendor' },
  { label: 'Product', value: 'product', id: 'product' },
  { label: 'Version', value: 'version', id: 'version' },
];

export const DefaultVisibilityState = {
  // Initialize entity types as visible by default
  [ResourceType.Risk]: true,
  [ResourceType.Technology]: true,
  [ResourceType.Webpage]: true,
  [ResourceType.Seed]: true,
  Tag: true,
  [ResourceType.Attribute]: true,
  SharpHound: true, // SharpHound clustering option
  // Initialize attributes as visible by default
  ...DefaultVisibleAttributes.reduce(
    (acc, current) => ({ ...acc, [current]: true }),
    {} as Record<string, boolean>
  ),
};
